/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { useActions } from 'common/hooks/useActions';
import StatusChip from 'components/statusChip';

import * as S from './styles';

interface IProps {
  data?: any;
}

/**
 * The counts strip above the reservation table.
 *
 * It replaces four floating white boxes, each carrying a coloured folder
 * icon in a circle — the icons overlapped their own boxes, the four counts
 * were painted `#2B3674`, `#1DBAAF`, `#20CAFF` and `#FF6464` (four raw hexes,
 * none of them on the palette), and nothing tied a tile to the Status column
 * it was counting.
 *
 * This is a summary of that column, so it reads like it: one card, four
 * cells divided by hairlines, and each status labelled with the exact chip
 * the table draws for it. Now the eye can go from the tile to the rows.
 *
 * `Total` carries no chip on purpose — it is a sum, not a state, and the one
 * plain label marks it as the different kind of thing it is.
 */
export default function ReservationCounts({ data }: IProps) {
  const { reservationStatisticsRequestAction } = useActions();

  useEffect(() => {
    reservationStatisticsRequestAction();
  }, []);

  return (
    <S.Card>
      <S.Cell>
        <S.PlainLabel>Total</S.PlainLabel>
        <S.Count>{data?.all ?? 0}</S.Count>
      </S.Cell>
      <S.Cell>
        <StatusChip domain="reservation" value="active" />
        <S.Count>{data?.total_active ?? 0}</S.Count>
      </S.Cell>
      <S.Cell>
        <StatusChip domain="reservation" value="completed" />
        <S.Count>{data?.total_complete ?? 0}</S.Count>
      </S.Cell>
      <S.Cell>
        <StatusChip domain="reservation" value="canceled" />
        <S.Count>{data?.total_canceled ?? 0}</S.Count>
      </S.Cell>
    </S.Card>
  );
}
